// https://en.wikipedia.org/wiki/Code_generation_(compiler)

import { Utils } from '../core/utils';
import { extractChunksFromLine, TextChunk, TextChunkKind } from './text.model';
import { TextViewNode, TextViewNodeKind } from './text.view.div.ast';

export class CodeGenError {
  constructor(public message: string = 'unknown reason')
  {}

  public toString(): string
  {
    return 'chunk generation failed: ' + this.message;
  }
}

function emitWordSequence(node: TextViewNode): Array<TextChunk>
{
  return extractChunksFromLine(node.content);
}

function emitLine(node: TextViewNode): Array<TextChunk>
{
  return Utils.flattenArray([
    Utils.flattenArray((node.children || []).map(emitTextChunks)),
    node.ignoreLineBreak
      ? []
      : [{ kind: TextChunkKind.Whitespace, content: '', breaksLine: true }],
  ]);
}

function emitEmptyWord(node: TextViewNode): Array<TextChunk>
{
  return [];
}

function emitSelection(node: TextViewNode): Array<TextChunk>
{
  return [{kind: TextChunkKind.Control, selection: node.selection}];
}

export function emitTextChunks(node: TextViewNode): Array<TextChunk>
{
  switch (node.kind) {
    case TextViewNodeKind.WordSequence: return emitWordSequence(node);
    case TextViewNodeKind.Line: return emitLine(node);
    case TextViewNodeKind.EmptyWord: return emitEmptyWord(node);
    case TextViewNodeKind.Selection: return emitSelection(node);
    default: throw new CodeGenError('unexpected ast node');
  }
}



// WEBPACK FOOTER //
// ./src/app/text/text.view.div.codegen.ts